import { sortArrayBy } from '@domain-group/javascript-utils'

import type { ServiceModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

type FilterCategoriesByServiceParams = {
  service: ServiceModel,
  serviceCategories: EntitiesState['serviceCategories'],
}

const filterCategoriesByService = (params: FilterCategoriesByServiceParams) => {
  const { service, serviceCategories } = params

  const filtered = Object.values(serviceCategories)
    .filter(category => service.id === category.service_id)

  const sorted = sortArrayBy(filtered, 'asc', 'title')

  return sorted
}

export default filterCategoriesByService
